import React from 'react';
import TextFieldDate from '../../UI/TextFieldDate';
import TextField from '../../UI/TextField';
import Form from '../../UI/Form';
import dayjs from 'dayjs';

const CronogramaQuantAulaDiaForm = ({ cqad, setCqad, clickSubmit, handleRemove, isLoadingAction }) => {
    const onChangeDate = (data) => {
        setCqad((prevState) => ({
            ...prevState,
            data: dayjs(data)
        }))
    }

    const onChange = (event) => {
        setCqad((prevState) => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    return (
        <>
            <Form
                clickSubmit={clickSubmit}
                handleClose={() => setCqad(null)}
                handleRemove={handleRemove}
                isLoadingAction={isLoadingAction}
            >
                <TextFieldDate
                    onChange={onChangeDate}
                    value={cqad.data ? cqad.data : null}
                    label="Data"
                />
                <TextField
                    label="Quantidade Aulas"
                    onChange={onChange}
                    name="quantAulas"
                    value={cqad.quantAulas}
                />


            </Form>
        </>
    )
}

export default CronogramaQuantAulaDiaForm;